module.exports = __webpack_public_path__ + "img/riointbig4.580c2ffc.png";